'use client';

import classNames from 'classnames';
import { usePathname } from 'next/navigation';

const responsivePages = ['/', '/apti', '/info', '/event/invitation'];

export default function ResponsiveWrapper({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  return (
    <div id="wrap" className={classNames({ responsive: responsivePages.includes(pathname) })}>
      {children}
    </div>
  );
}
